import { Avatar, Card, Image } from "antd";
import colors from "../../../../constants/colors";

type Message = {
  type: string;
  user: {
    avatar: string;
    status: string;
  };
  message: {
    text: string;
    file: string;
    file_type: string;
    voice: string;
  };
  created_at: string;
};

type Props = { message: Message };

const MessageBodyItem = ({ message }: Props) => {
  return (
    <div className="flex gap-4">
      <div>
        <span className="relative inline-block shrink-0">
          <Avatar src={message?.user?.avatar} size={56} />
          <span
            className="absolute bottom-1 right-1 block w-3 h-3 rounded-full border-2 border-white"
            style={{
              background:
                message?.user?.status === "online"
                  ? colors.success.color
                  : "#AAB3C3",
            }}
          />
        </span>
      </div>

      {/* Message */}
      <div className="grow w-full space-y-2.5">
        {message?.message?.file && message?.message?.file_type === "pdf" ? (
          <Card className="w-80" classNames={{ body: "!p-0" }}>
            <div className="flex items-center justify-between p-4">
              <div className="flex items-center space-x-2">
                <span className="font-medium text-header text-xs">
                  Human Design Guidelines <span className="">.pdf</span>
                </span>
              </div>
              <span className="text-primary text-xs font-medium">
                760.90 KB
              </span>
            </div>

            <button className="bg-primary/5 text-primary font-bold text-xs block w-full px-4 py-2">
              Downloading ...
            </button>
          </Card>
        ) : null}
        {message?.message?.file && message?.message?.file_type === "image" ? (
          <div className="flex items-center gap-5 flex-wrap">
            <Image
              className="rounded-[5px]"
              src="https://picsum.photos/300/200"
              width={225}
              height={165}
            />
          </div>
        ) : null}
        {message?.message?.text ? (
          <p className="text-xs text-[#6B7A99] leading-5 max-w-[400px]">
            {message?.message?.text}
          </p>
        ) : null}

        <span className="text-xs text-[#8897AE] block">12:45</span>
      </div>
    </div>
  );
};

export default MessageBodyItem;
